import { useCallback, useState } from 'react';

export const DEFAULT_CATEGORY = 'Legal';

interface UseCategorySearchReturn {
  selectedCategory: string | null;
  handleCategorySelect: (category: string) => void;
  resetCategory: () => void;
}

export function useCategorySearch(
  searchQuery: string,
  onSearch: (query: string) => void,
): UseCategorySearchReturn {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(DEFAULT_CATEGORY);

  const handleCategorySelect = useCallback(
    (category: string) => {
      const newCategory = selectedCategory === category ? null : category;
      setSelectedCategory(newCategory);
      onSearch(newCategory || searchQuery);
    },
    [selectedCategory, searchQuery, onSearch],
  );

  const resetCategory = useCallback(() => {
    setSelectedCategory(null);
  }, []);

  return {
    selectedCategory,
    handleCategorySelect,
    resetCategory,
  };
}
